// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1fra3","detailsBorder":"styles_detailsBorder__1Uuk4"};